import React from "react";
import "./styles/Menu.css";
import "./styles/HamburgerMenu.css";
import { BrowserRouter as Router, Routes, Link, Route } from "react-router-dom";
import "./styles/Footer.css";
import { Onama } from "./Onama";
import { Kontakt } from "./Kontakt";
import { Tim } from "./Tim";
import { Galerija } from "./Galerija";
import { Portfolio } from "./Portfolio";
import { LoadingSpinner } from "./LoadingSpinner";

function App() {
  const [isFixed, setIsFixed] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 sekunde loading

    return () => clearTimeout(timer);
  }, []);

  // Auto-collapse mobile menu when clicking on navigation links
  React.useEffect(() => {
    const handleNavLinkClick = () => {
      // Check if we're on mobile (hamburger menu is visible)
      const hamburgerLabel = document.querySelector(".hamburger-label");
      if (
        hamburgerLabel &&
        window.getComputedStyle(hamburgerLabel).display !== "none"
      ) {
        // Close the mobile menu by unchecking the hamburger checkbox
        const hamburgerCheckbox = document.querySelector(
          ".hamburger-checkbox"
        ) as HTMLInputElement;
        if (hamburgerCheckbox && hamburgerCheckbox.checked) {
          hamburgerCheckbox.checked = false;
        }
      }
    };

    // Add event listeners to all navigation links
    const navLinks = document.querySelectorAll(".navbar-nav a");
    navLinks.forEach((link) => {
      link.addEventListener("click", handleNavLinkClick);
    });

    // Cleanup event listeners
    return () => {
      navLinks.forEach((link) => {
        link.removeEventListener("click", handleNavLinkClick);
      });
    };
  }, []);

  return (
    <>
      {isLoading && (
        <LoadingSpinner size="large" text="Učitavanje..." overlay={true} />
      )}

      <Router>
        <header className={`main-header ${isFixed ? "fixed-nav" : ""}`}>
          <nav className="navbar navbar-expand-lg">
            <div className="container">
              {/* CSS-Only Hamburger Menu */}
              <input
                type="checkbox"
                id="hamburger-checkbox"
                className="hamburger-checkbox"
              />
              <label htmlFor="hamburger-checkbox" className="hamburger-label">
                <span className="hamburger-icon"></span>
              </label>

              <a className="navbar-brand" href="/">
                <img
                  alt="CreativeHub Logo"
                  style={{ width: "170px" }}
                  src="images/CREATIVEHUBCRNI.png"
                />
              </a>

              {/* Desktop Menu */}
              <div className="desktop-menu">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      O Nama
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/portfolio">
                      Portfolio
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/galerija">
                      Galerija
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/kontakt">
                      Kontakt
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/tim">
                      Tim
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Mobile Menu */}
              <div className="mobile-menu">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      O Nama
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/portfolio">
                      Portfolio
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/galerija">
                      Galerija
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/kontakt">
                      Kontakt
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/tim">
                      Tim
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<Onama />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/galerija" element={<Galerija />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/tim" element={<Tim />} />
        </Routes>

        <footer className="footer-section">
          <div className="container">
            <div className="footer-content">
              <div className="footer-about">
                <div className="footer-logo">
                  <img
                    src="images/CREATIVEHUBCRNI.png"
                    alt="Creativehub Logo"
                  />
                </div>
                <p>
                  Agencija specijalizovana za PR i video produkciju, posvećena
                  kreiranju vrhunskih komunikacionih strategija i sadržaja.
                </p>
              </div>
              <div className="footer-links">
                <h4>Brzi linkovi</h4>
                <ul>
                  <li>
                    <Link to="/">O Nama</Link>
                  </li>
                  <li>
                    <Link to="/portfolio">Portfolio</Link>
                  </li>
                  <li>
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li>
                    <Link to="/kontakt">Kontakt</Link>
                  </li>
                  <li>
                    <Link to="/tim">Tim</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-social">
                <h4>Pratite nas</h4>
                <div className="social-icons">
                  <a
                    href="https://www.facebook.com/profile.php?id=100094573102351&mibextid=ViGcVu"
                    className="facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Pratite nas na Facebook-u"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://x.com/djedovina?t=WsOH3Nu6OQShkelHzoBoYA&s=09"
                    className="twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Pratite nas na X-u"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@creativehubmne"
                    className="youtube"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Pratite nas na YouTube-u"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    href="https://instagram.com/djedovinacg?igshid=OTBlMGdoamE5YWZx"
                    className="instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Pratite nas na Instagram-u"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.tiktok.com/@djedovina?_t=8hCK6LV8heP&_r=1"
                    className="tiktok"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Pratite nas na TikTok-u"
                  >
                    <i className="fab fa-tiktok"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <span>
                Copyright © 2025. All rights reserved&nbsp;
                <a href="https://www.creativehubmne.com/">Creativehub</a>
              </span>
            </div>
          </div>
        </footer>
      </Router>
    </>
  );
}

export default App;
